import React from "react";
import "./Auth.css";
import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { db, auth } from "../../firebase-config";
import { MoonLoader } from "react-spinners";
import { EyeSlash, EyeFill } from "react-bootstrap-icons";
import LoadScreen from "../LoadScreen";
import loader from "../../images/main-loader.jpg";
import { doc, setDoc } from "firebase/firestore";
import ReCAPTCHA from "react-google-recaptcha";

const SignUp = () => {
  const siteKey = "6Lf3VwIiAAAAAM0OueZ7K7yt8VpmyiK0Oks-2t49";
  const [recaptcha, setRecaptcha] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState("");

  const [registerEmail, setRegisterEmail] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerConfirmPassword, setRegisterConfirmPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordErrorMsg, setpasswordErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");

  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const register = async (event) => {
    event.preventDefault();
    var minNumberofChars = 6;
    var maxNumberofChars = 16;
    var regularExpression = /^(?=.*[\d])(?=.*[!@#$%^&*])[\w!@#$%^&*]{6,16}$/;

    try {
      if (recaptcha) {
        const userCredentials =
          //  await signup(registerEmail, registerPassword);
          // history.push("/")
          await createUserWithEmailAndPassword(
            auth,
            registerEmail,
            registerPassword
          );
        const user = userCredentials.user;
        const currentUser = user.currentUser;

        if (userCredentials) {
          await setDoc(doc(db, "userInfo", registerEmail), {
            email: registerEmail,
            uid: auth.currentUser.uid,
          });
        }
        // console.log("current User = " + JSON.stringify(auth.currentUser));
        setErrorMsg("");
        setEmailErrorMsg("");
        setpasswordErrorMsg("");
        setIsLoading(true);
        setSuccessMsg("Account Created Successfully !");
        setRecaptchaError("");

        // console.log(auth.currentUser.email);

        setTimeout(() => {
          setIsLoading(false);
          // console.log("Tried nav");
        }, 2000);

        setRedirect(true);
        try {
          await sendEmailVerification(user);
        } catch (error) {
          // console.log(error.message);
        }
      } else setRecaptchaError("Please check Recapthca");
    } catch (error) {
      if (recaptcha == false) setRecaptchaError("Please check Recapthca");

      if (
        !regularExpression.test(registerPassword) ||
        registerPassword.length < minNumberofChars ||
        registerPassword.length > maxNumberofChars
      ) {
        setpasswordErrorMsg(
          "Password should contain atleast one number and one special character and should contain 8-16 characters."
        );
      }
      if (registerEmail.length == 0) {
        setEmailErrorMsg("Email cannot be empty");
      }

      if (registerPassword.length == 0) {
        setpasswordErrorMsg("Password cannot be empty");
      }

      if (error.message == "Firebase: Error (auth/email-already-in-use).") {
        setEmailErrorMsg("Email already in use !");
      }

      if (
        registerEmail.length != 0 &&
        error.message == "Firebase: Error (auth/invalid-email)."
      ) {
        setEmailErrorMsg("Invalid Email Used");
      } else {
        setErrorMsg("Account could not be created !");
      }

      if (setpasswordErrorMsg == "") console.log(error.message);

      setSuccessMsg("");
      // console.log(error.message);
    }

    setTimeout(() => {
      setErrorMsg("");
      setEmailErrorMsg("");
      setpasswordErrorMsg("");
      setRecaptchaError("");
    }, 7000);
  };

  const renderRedirect = () => {
    if (redirect) return <Navigate to="/VerifyEmail" />;
  };
  return (
    <>
      {isLoading ? (
        <LoadScreen />
      ) : (
        <div className="createAcDiv">
          {/* v1!edangsar */}
          <section id="contact">
            <div className="contact-box">
              <div className="contact-links">
                <h2 className="signUpHeader">Create Account</h2>
                <img src={loader} height="150px" width="100%" alt="AVION" />
                <div className="createAcSpan">
                  By creating an account you will be able to save your addresses
                  and save items in cart.
                </div>
              </div>

              <div className="contact-form-wrapper">
                {successMsg && (
                  <>
                    <div className="successDiv">{successMsg}</div>
                  </>
                )}
                {errorMsg && (
                  <>
                    <div className="errorDiv">{errorMsg}</div>
                  </>
                )}
                <form className="signUpForm" method="POST">
                  {renderRedirect()}
                  <div className="form-item">
                    <input
                      className="inputFields"
                      type="text"
                      onChange={(event) => {
                        setRegisterEmail(event.target.value);
                      }}
                      value={registerEmail}
                      name="email"
                      required
                    />
                    <label>Email</label>
                    <div className="inputErrors">{emailErrorMsg}</div>
                  </div>

                  <div className="form-item">
                    <input
                      className="inputFields"
                      type={passwordType}
                      onChange={(event) => {
                        setRegisterPassword(event.target.value);
                        // handlePasswordChange();
                      }}
                      name="password"
                      value={registerPassword}
                      required
                    />
                    <label>Password</label>
                    <div className="eye" onClick={togglePassword}>
                      {passwordType === "password" ? <EyeSlash /> : <EyeFill />}
                    </div>
                    <div id="passwordError" className="inputErrors">
                      {passwordErrorMsg}
                    </div>
                    <div className="form-item">
                      <ReCAPTCHA
                        onChange={() => setRecaptcha(true)}
                        sitekey={siteKey}
                      />
                      <div className="inputErrors">{recaptchaError}</div>

                    </div>

                    <div className="redirectLinksDiv">
                      <Link className="redirectLinks" to="/SignIn">
                        Already have an account?
                      </Link>
                    </div>
                  </div>

                  <button onClick={register} className="submit-btn">
                    Create Account
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default SignUp;
